<template>
  <BlockUI>
    <div class="loader"></div>
  </BlockUI>
</template>

<script>
const context_line = JSON.parse(localStorage.getItem('context_line'))
export default {
    mounted() {
        this.$liff.init({
            liffId: context_line.liffId
        })
        this.downloadQRCode()
    },
    methods: {
        async downloadQRCode() {
            const bookId = this.$route.query.bookId
            window.location.href = this.$API_URL + `/download/images/qrcode/${bookId}`
            // this.$liff.closeWindow()
        }
    }
}
</script>

<style>

</style>